import { UserCog } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerPersonasSpec: ModuleSpec = {
  id: "customer-personas",
  icon: UserCog,
  i18n: {
    namespace: "modules",
    titleKey: "customer-personas.title",
    descriptionKey: "customer-personas.description",
  },
  nav: {
    path: "/customers/personas",
    group: "observe",
    order: 80,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Create and manage customer personas",
  },
};
